import { overlay } from 'overlay-kit';
import { type OpenPlanStartModalProps } from '@/module/plan/types';
import { PlanStartModal } from '@/shared/components/PlanStartModal';
import { isInLtiContext } from '@/shared/lti';
export const openPlanStartModal = (props: OpenPlanStartModalProps) => {
  if (props.planType === 'FREE' || isInLtiContext()) return;
  // 모달 표시
  // 참고: shouldShowModal 체크는 NotifyPlanStartContainer에서 수행됨
  overlay.open(({
    unmount
  }) => <PlanStartModal {...props} onClose={unmount} />);
};